<template>
  <div class="upload_wrap">
    <div class="upload_content">
      <div class="upload_file" @click="uploadFiles">
        <div class="up_cons">
          <i class="el-icon-plus"></i>
          <span>添加主图</span>
          <span>（{{ modelValue.length }}/{{ limit }}）</span>
        </div>
      </div>
      <uploaderImage
        v-show="false"
        ref="uploadFile"
        @input="handleChange"
        uploadSize="20mb"
        :accept="accept"
        :isAddSucaiFlag="false"
        @uploadSucess="uploadSucess"
      />
      <div class="fileList_li" v-for="(item,index) in modelValue" :key="item">
        <img class="fileList_li_img" :src="item" alt="" />
        <div class="fileList_li_mask">
          <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview(item)"></i>
          <i class="el-icon-delete icon" @click="handleRemove(index)"></i>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="preivew_img_dialog"
      :modal="false"
    >
      <img width="100%" :src="selImage" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-unified";
import { mapActions } from "vuex";
import { uploadQiNiuyun } from "@/components/upload/upload.js";
import uploaderImage from "@/components/newUpload/upload.vue";
export default {
  components: {
    uploaderImage,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: Array,
      default: () => [".jpg", ".png", ".jpeg", ".tif", ".jfif"],
    },
    limit: {
      type: Number,
      default: 6,
    },
  },
  mixins: [uploadQiNiuyun],
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      sizeFlag: true,
      isUpload: false,
      selImage:''
    };
  },
  computed: {
    modelValue: {
      get() {
        console.log(this.value, this.limit, "value----");
        return cloneDeep(this.value);
      },
      set(news) {
        this.$emit("input", news);
        return news;
      },
    },
  },
  methods: {
    ...mapActions("uploads", ["getUploaderToken", "uploadImgToWxAPI"]),
    uploadFiles() {
      if(this.modelValue.length>=this.limit){
        return
      }
      this.$refs.uploadFile.uploadFile();
    },
    uploadSucess(list) {
      // this.$emit("input", list[0].url);
      console.log(list[0].url,'list[0].url')
      this.modelValue.push(list[0].url)
      this.modelValue = [...this.modelValue]
      // this.fileList.push(list[0].url)
      this.uploadImgToWxAPI({url: list[0].url}) // 图片url->后端->微信后端
    },
    handlePictureCardPreview(file) {
      this.selImage = file
      this.dialogVisible = true;
    },
    handleRemove(index) {
      // this.$emit("input", "");
      console.log(index,'index-----')
      this.modelValue.splice(index,1)
      this.modelValue = [...this.modelValue]
    },
    handleChange(){}
  }
};
</script>

<style lang="less">
.preivew_img_dialog {
  margin-top: 24px !important;
  min-width: 50%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    overflow-y: auto;
    flex: 1;
    height: 0;
  }
}
.upload_content {
  width:330px;
  display: flex;
  flex-wrap: wrap;
}
.upload_file {
  width: 100px;
  height: 100px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
}
.up_cons {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: #333;
  span{
   line-height: 20px;
  }
}
.fileList_li {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  margin: 0 8px 8px 0;
  display: inline-block;
  position: relative;
  .fileList_li_mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s linear;
    transform: translateY(-100%);
    .icon {
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      &:nth-child(2) {
        margin-left: 6px;
      }
    }
  }
  &:hover .fileList_li_mask {
    transform: translateY(0);
  }
  .fileList_li_img {
    width: 100%;
    object-fit: cover;
    height: 100px;
  }
}
</style>